import { gql } from '@apollo/client/core'

export const DOMICILIATION_VALIDATION = gql`
  mutation domiciliationPartnerValidation(
    $domiciliationId: ID!,
    $validated: Boolean!,
    $message: String
  ) {
    domiciliationPartnerValidation(
      domiciliationId: $domiciliationId,
      validated: $validated,
      message: $message
    ) {
      domiciliation {
        id
      }
    }
  }
`

export interface DomiciliationValidationVariables {
  domiciliationId: number,
  validated: boolean,
  message?: string
}

export interface DomiciliationValidationResult {
  domiciliationPartnerValidation: {
    domiciliation: {
      id: number
    }
  }
}
